export default [
  {
    name: 'Экономика',
    description:
      'Экономика во всем ее многообразии подходов и течений — это моя страсть, которая развивалась со времен старшей школы, когда я участвовал в олимпиаде. Любопытство к тому, как можно управлять государством, стало вдохновением для создания моей платформы политических тестов Soulgraphy.',
    image: 'kanada',
  },
  {
    name: 'Природа и животный мир',
    description:
      'С ранних лет меня увлекает животный мир и среда, в которой они обитают. В детстве я хотел стать зоологом.',
    image: 'seal',
  },
  {
    name: 'Страны мира',
    description:
      'С каждым годом меня все больше увлекает изучение различных уголков мира. То, как языки формировались с течением времени, помогает лучше понять культуру и образ мышления людей из разных стран. Погружаясь в их историю, легче увидеть, что влияет на то, как выглядит их настоящее. Особенно меня интересуют страны Северной Европы и Япония.',
    image: 'japan',
  },
  {
    name: 'Электронные технологии',
    description:
      'Электроника, программирование или телекоммуникационные технологии — это для меня не просто интересная область науки. Прежде всего, это инструмент, благодаря которому я могу почувствовать себя изобретателем и самостоятельно создавать собственные электронные схемы или веб-приложения.',
    image: 'telecommunications',
  },
  {
    name: 'Физика и технологии',
    description:
      'Мне всегда было интересно, как устроен мир. Неважно, идет ли речь о токе в лампочке или о том, почему светит солнце. Физика для меня — это процесс познания мира и понимания того, почему он ведет себя так, а не иначе. Использование этих знаний дает блестящим умам инструменты для создания инновационных решений, которые меняют мир на наших глазах — от дешевой и чистой энергии до эффективных батарей и спасающих жизнь лекарств.',
    image: 'physics',
  },
  {
    name: 'Готовка',
    description:
      'Я люблю готовить и экспериментировать на кухне, а приготовление пасты или мяса является неотъемлемой частью моего дня. Помимо польской кухни, я обожаю корейские и индийские блюда.',
    image: 'cooking',
  },
  {
    name: 'Фэнтези, игры и отдых',
    description:
      'Никто в здравом уме не возвращается с работы на очередную работу, потому что всем нужен отдых и время, чтобы отвлечься от повседневной рутины. И когда я это делаю, я обычно смотрю фильмы, изучаю (и пишу) фэнтези, отправляюсь в поездки на машине или играю в самые разные игры с друзьями.',
    image: 'relax',
  },
]
